/* tslint:disable */
/* eslint-disable */
/**
 * DexIt
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { EventTypeResponseModel } from '../Models';
/**
 * EventTypeApi - axios parameter creator
 * @export
 */
export const EventTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventHandlers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/eventType/getAllEventHandlers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isusersubscribable] 
         * @param {boolean} [isworkflowsubscribable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventTypes: async (isusersubscribable?: boolean, isworkflowsubscribable?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/eventType/getAllEventTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (isusersubscribable !== undefined) {
                localVarQueryParameter['isusersubscribable'] = isusersubscribable;
            }

            if (isworkflowsubscribable !== undefined) {
                localVarQueryParameter['isworkflowsubscribable'] = isworkflowsubscribable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventTypeApi - functional programming interface
 * @export
 */
export const EventTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEventHandlers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEventHandlers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypeApi.getAllEventHandlers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isusersubscribable] 
         * @param {boolean} [isworkflowsubscribable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEventTypes(isusersubscribable?: boolean, isworkflowsubscribable?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventTypeResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEventTypes(isusersubscribable, isworkflowsubscribable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypeApi.getAllEventTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventTypeApi - factory interface
 * @export
 */
export const EventTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventHandlers(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllEventHandlers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isusersubscribable] 
         * @param {boolean} [isworkflowsubscribable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEventTypes(isusersubscribable?: boolean, isworkflowsubscribable?: boolean, options?: any): AxiosPromise<Array<EventTypeResponseModel>> {
            return localVarFp.getAllEventTypes(isusersubscribable, isworkflowsubscribable, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventTypeApi - interface
 * @export
 * @interface EventTypeApi
 */
export interface EventTypeApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApiInterface
     */
    getAllEventHandlers(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 
     * @param {boolean} [isusersubscribable] 
     * @param {boolean} [isworkflowsubscribable] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApiInterface
     */
    getAllEventTypes(isusersubscribable?: boolean, isworkflowsubscribable?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventTypeResponseModel>>;

}

/**
 * EventTypeApi - object-oriented interface
 * @export
 * @class EventTypeApi
 * @extends {BaseAPI}
 */
export class EventTypeApi extends BaseAPI implements EventTypeApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    public getAllEventHandlers(options?: RawAxiosRequestConfig) {
        return EventTypeApiFp(this.configuration).getAllEventHandlers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isusersubscribable] 
     * @param {boolean} [isworkflowsubscribable] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    public getAllEventTypes(isusersubscribable?: boolean, isworkflowsubscribable?: boolean, options?: RawAxiosRequestConfig) {
        return EventTypeApiFp(this.configuration).getAllEventTypes(isusersubscribable, isworkflowsubscribable, options).then((request) => request(this.axios, this.basePath));
    }
}

